import React, {Component} from "react";
import {Card, CardTitle, CardText, Button, Row, Col} from 'reactstrap';
import {CALCULATE_RISK, RISK_COLOR} from "../Constants";

function renderTextWithLineBreaks(text) {
    if (!text) { // This will catch null, undefined, and empty string
        return null; // Or return a default value or component
    }
    return text.split('\n').map((line, index) => (
      <span key={index}>
        {line}
        <br />
      </span>
    ));
  }

export default class RouteRiskAssessment  extends Component{

    constructor(props) {
        super(props);
    }


    render(){

        const {
            data,
            model,
            id
        } = this.props;

        const{color} = RISK_COLOR(model.base_line);
        return(
            <div>
                <Card body color={"#eee"}>
                    <Row>
                        <Col>
                            <p className="margin-5">
                                <span className="attribute">Name:</span> <span className="attribute-details">Route risk assessment template - {model.name}</span>
                            </p>
                            <p className="margin-5">
                                <span className="attribute">Task ID:</span> <span className="attribute-details">{`${model.risk_id} - ${model.id}`}</span>
                            </p>
                            <p className="margin-5"><span className="attribute">Assessment Date: </span><span className="attribute-details">{data.assessment_date}</span></p>
                            <p className="margin-5"><span className="attribute">Route Name:</span> <span className="attribute-details">{data.route_name}</span></p>
                            <h6>Optimum Traffic Patterns and Times:</h6>
                            <p className="controls">{renderTextWithLineBreaks(data.optimum_traffic_patterns_times)}</p>
                            <h6>Highly Hazardous intersections Along Routes:</h6>
                            <p className="controls">{renderTextWithLineBreaks(data.highly_hazardous_intersections_along_routes)}</p>
                            <h6>Any Overhead Hazards:</h6>
                            <p className="controls">{renderTextWithLineBreaks(data.any_overhead_hazards)}</p>
                        </Col>
                        <Col>
                            <h6>Construction Along Routes:</h6>
                            <p className="controls">{renderTextWithLineBreaks(data.construction_along_routes)}</p>
                            <h6>Access To Delivery Points Along Routes:</h6>
                            <p className="controls">{renderTextWithLineBreaks(data.access_to_delivery_points_along_routes)}</p>
                            <h6>Make-up and Tonnage of Each Shipment:</h6>
                            <p className="controls">{renderTextWithLineBreaks(data.makeup_and_tonnage_of_each_shipment)}</p>
                        </Col>
                    </Row>
                    <hr/>
                    <Row className="rating" style={{backgroundColor: color}}>
                        <Col>
                            <div>
                                <h6>Risk Rating:</h6>
                                <p className="margin-5"><span>Severity:</span> <span>{data.severity}</span></p>
                                <p className="margin-5"><span>Likelihood:</span> <span>{data.likelihood}</span></p>
                            </div>
                        </Col>
                        <Col>
                            <h6>Baseline Risk:</h6>
                            <p className="baseline">{model.base_line}</p>
                        </Col>
                    </Row>
                </Card>
            </div>
        )
    }
}





// WEBPACK FOOTER //
// ./src/screens/risks/lists/RouteRiskAssessment.js